import { makeObservable, observable, action } from "mobx";
import { set } from "../../utils/immutable";
import { TRichModalFileStatus } from "./types";
import {
  getFileSign,
  uploadFile,
  commitFile,
  getParseStatus,
  deleteFile,
} from "../../services/richmodal";
import type { UploadedFile, IRichModalFile } from "../../objects/file/types";
import {
  ERichModalFileParseStatus,
  ERichModalFileNormStatus,
} from "../../objects/file/types";
import { isFileListValid } from "./utils";
import { delay } from "../../utils";
import PromiseAllLimit from "../../utils/PromiseAlllimit";
import { cacheFile } from "../../services/videoEdit";

export const getSingleFileSign = async (file: File) => {
  try {
    const res = await getFileSign([file]);
    return res[0];
  } catch (e) {
    return false;
  }
};

export async function uploadAndCommitFile(file: File, commitUrl?: string) {
  const fileSignInfo = await getSingleFileSign(file);
  if (!fileSignInfo) {
    return { status: "error", file_name: file.name, url: "" };
  }
  const fileInfo = await uploadFile(fileSignInfo, file);
  console.log("[uploadAndCommitFile] fileInfo", fileInfo);
  if (fileInfo.status !== "success") {
    return fileInfo;
  }
  const [res] = await commitFile([fileSignInfo.file_id], [], commitUrl || "");
  if (res?.status === "success") {
    return fileInfo;
  } else {
    // throw new Error();
    return {
      ...fileInfo,
      status: res?.status || "error",
    };
  }
}

export async function uploadAndCommitCache(file: File, key: string) {
  const fileSignInfo = await getSingleFileSign(file);
  if (!fileSignInfo) {
    return { status: "error", file_name: file.name, url: "" };
  }
  const fileInfo = await uploadFile(fileSignInfo, file);
  console.log("[uploadAndCommitFile] fileInfo", fileInfo);
  if (fileInfo.status !== "success") {
    return fileInfo;
  }
  await cacheFile([
    {
      key: key,
      file_id: fileSignInfo.file_id,
    },
  ]);
  return fileInfo;
}

export interface IOptions {
  uploadFn?: (file: File) => Promise<UploadedFile>;
  deleteFn?: (file_id: string) => Promise<any>;
  accept: string;
  maxFileSize: number;
  maxFileNumber: number;
}

class FileManagerModel {
  fileList: IRichModalFile[] = [];

  globalError: TRichModalFileStatus | null = null;

  // @observable.ref accessor aaa: any = {};

  parseStatusQuering: boolean = false;

  maxFileSize: number;
  maxFileNumber: number;

  constructor({ maxFileSize, maxFileNumber }: IOptions) {
    makeObservable(this, {
      fileList: observable.ref,
      globalError: observable,
      setFileList: action,
      setGlobalError: action,
    });
    this.maxFileSize = maxFileSize;
    this.maxFileNumber = maxFileNumber;
  }

  init() {
    this.setFileList([]);
    this.setGlobalError(null);
    this.parseStatusQuering = false;
  }

  setFileList(v: IRichModalFile[]) {
    this.fileList = v;
  }

  setGlobalError(v: TRichModalFileStatus | null) {
    this.globalError = v;
  }

  deleteFile = (v: IRichModalFile) => {
    const newFileList = this.fileList.filter(item => item.file !== v.file);
    this.setFileList(newFileList);
    if (v?.uploadInfo) {
      deleteFile(v.uploadInfo.file_id!);
    }
    // if (
    //   !this.parseStatusQuering &&
    //   newFileList.every(item => item.uploadInfo)
    // ) {
    //   this.startQueryFileParseStatus();
    // }
  };

  addFiles = async (files: File[]) => {
    try {
      await this.uploadFiles([...files]);
    } catch (e: any) {
      if (e?.code) {
        this.setGlobalError(ERichModalFileNormStatus.netError);
      } else {
        this.setGlobalError(ERichModalFileNormStatus.error);
      }
    }
  };

  uploadFiles = async (list: File[]) => {
    const files: File[] = [...list];
    const appendFileList: IRichModalFile[] = await Promise.all(
      files.map(async (item: File) => {
        const result = await isFileListValid([item], this.maxFileSize);
        let validateInfo: IRichModalFile["validateInfo"] = undefined;
        if (result.emptyFiles.length) {
          validateInfo = { type: "emptyFiles" };
        } else if (result.extensionErrorFiles.length) {
          validateInfo = { type: "extensionErrorFiles" };
        } else if (result.notUTF8PlainTextFiles.length) {
          validateInfo = { type: "notUTF8PlainTextFiles" };
        } else if (result.overSizeFiles.length) {
          validateInfo = { type: "overSizeFiles" };
        } else if (result.tooLargeImage.length) {
          validateInfo = { type: "tooLargeImage" };
        }
        // else if(result.tooSmallImage.length){
        //   validateInfo = {type:"tooSmallImage"}
        // }
        return {
          file: item,
          validateInfo,
          uploadInfo: null,
          parseInfo: null,
          // parseInfo: {
          //   id: "1",
          //   state: ENovaFileParseStatus.completed,
          //   comprehend: 1,
          //   is_simple_file: false,
          //   token_count: 100,
          // },
        };
      }),
    );
    const newFileList: IRichModalFile[] = [...this.fileList, ...appendFileList];
    this.setFileList(newFileList);
    const uploadList = appendFileList
      .filter(item => !item.validateInfo)
      .map(item => item.file);
    if (!uploadList.length) {
      return;
    }
    // const res = await getFileSign(uploadList);
    // 解决不了Md5重合问题,暂时单个签名
    // const res = await Promise.all(
    //   uploadList.map(item => getSingleFileSign(item)),
    // );
    // await PromiseAllLimit(
    //   uploadList.map(file => () => {
    //     const fileSignInfo = res.find(item => item.name === file.name);
    //     if (fileSignInfo) {
    //       return this.uploadFile(file, fileSignInfo);
    //     } else {
    //       return Promise.resolve();
    //     }
    //   }),
    //   3,
    // );
    await PromiseAllLimit(
      uploadList.map(file => () => this.uploadFile(file)),
      3,
    );
    // this.parseStatusQuering = false;
    // return;
    if (
      this.fileList.some(
        item => item.uploadInfo && item.uploadInfo.status === "success",
      )
    ) {
      this.startQueryFileParseStatus();
    }
  };

  async uploadFile(file: File) {
    return uploadAndCommitFile(file).then((info: UploadedFile) => {
      const fileIndex = this.fileList.findIndex(it => it.file === file);
      const temp = set<IRichModalFile[]>(
        this.fileList,
        [fileIndex, "uploadInfo"],
        info,
      );
      this.setFileList(temp);
    });
  }

  // async commitFile(list: File[]) {
  //   const files = this.fileList.filter(item =>
  //     list.some(it => it === item.file),
  //   );
  //   await commitNovaFile(files.map(item => item.uploadInfo!));
  // }

  async queryFileParseStatus() {
    const files = this.fileList.reduce<IRichModalFile[]>((pre, cur) => {
      if (cur.uploadInfo && cur.uploadInfo.status === "success") {
        pre.push(cur);
      }
      return pre;
    }, []);
    const res = await getParseStatus(
      files.map(item => item.uploadInfo!.file_id!),
    );

    let temp = [...this.fileList];
    res.forEach(item => {
      const fileIndex = temp.findIndex(
        it => it.uploadInfo?.file_id === item.file_id,
      );
      if (fileIndex > -1) {
        temp = set<IRichModalFile[]>(temp, [fileIndex, "parseInfo"], item);
      }
    });
    this.setFileList(temp);

    return (
      res.every(item => item.status !== ERichModalFileParseStatus.running) &&
      !this.fileList.find(
        item => !item.parseInfo && item.uploadInfo?.status === "success",
      )
    );
  }

  async startQueryFileParseStatus() {
    if (this.parseStatusQuering) return;
    if (this.globalError) {
      this.setGlobalError(null);
    }
    try {
      this.parseStatusQuering = true;
      while (this.parseStatusQuering) {
        const res = await this.queryFileParseStatus();
        if (res) {
          this.parseStatusQuering = false;
        } else {
          await delay(5000);
        }
      }
    } catch (e) {
      this.parseStatusQuering = false;
      this.setGlobalError(ERichModalFileNormStatus.netError);
    }
  }
}

export default FileManagerModel;
